import React from "react";
import { Button, Grid } from "@mui/material";
import { lighten, useTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { TnAOverviewDTO } from "../../../../models/tna-overviews";
import { AddEditTimesheetConfirmationRequest } from "../../TnATimeSheetConfirmation/AddEditTimesheetConfiirmationRequest/AddEditTimesheetConfirmationRequest";
import ConfirmationDialog, {
  DialogOptions,
} from "../../TnATimeSheetConfirmation/ConfirmationDialog/ConfirmationDialog";
import { TnATimesheetConfirmationSTO } from "../../../../models/tna-timesheet-confirmation";
import { useTranslation } from "react-i18next";

interface Props {
  item: TnAOverviewDTO;
  showReminderRequest: boolean;
  showSignoffRequest: boolean;
  showCancellRequest: boolean;
  handleNotifyParent: () => void;
  handleRemindRequest?: () => void;
  handleCancelRequest?: () => void;
  Icon?: React.ReactNode;
}

const TnAOverviewActions = ({
  item,
  showReminderRequest,
  showCancellRequest,
  showSignoffRequest,
  handleNotifyParent,
  handleRemindRequest,
  handleCancelRequest,
  Icon,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.team_presence_and_leaves_dashboard";
  const theme = useTheme();
  return (
    <>
      <SimplePopover
        buttonType="icon"
        buttonContent={Icon ? Icon : <FontAwesomeIcon icon={faEllipsisH} />}
        customButtonStyle={{ color: lighten(theme.palette.primary.main, 0.5) }}
      >
        <Grid>
          {showSignoffRequest && item.tnATimesheetConfirmations && (
            <AddEditTimesheetConfirmationRequest
              effect={"add"}
              asLink={true}
              linkText={`${t(`${tRP}.send_signoff_request`)}`}
              handleNotifyParent={handleNotifyParent}
              item={item.tnATimesheetConfirmations}
              readOnly={false}
            />
          )}
          {showReminderRequest && handleRemindRequest && (
            <Button onClick={handleRemindRequest}>{`${t(`${tRP}.send_signoff_reminder`)}`}</Button>
          )}
        </Grid>

        {handleCancelRequest &&
          showCancellRequest &&
          !item.tnATimesheetConfirmations?.isSignedOff &&
          item.tnATimesheetConfirmations?.asOfDate && (
            <Grid>
              <ConfirmationDialog
                item={item.tnATimesheetConfirmations as TnATimesheetConfirmationSTO}
                sendRequest={(item) => handleCancelRequest()}
                disabled={false}
                option={DialogOptions.cancel}
              >
                <Button>{`${t(`${tRP}.cancel_signoff_request`)}`}</Button>
              </ConfirmationDialog>
            </Grid>
          )}
      </SimplePopover>
    </>
  );
};
export default TnAOverviewActions;
